<script>
import gql from 'graphql-tag'
import { GET_PAYOUT_STATS_QUERY } from '@/graph/gql/user.gql'

export default {
  name: 'PayoutsView',
  components: {
    ActiveDealsWrapper: () => import('@/components/charts/ActiveDealsWrapper')
  },
  apollo: {
    payoutStats: {
      query: GET_PAYOUT_STATS_QUERY,
      fetchPolicy: 'cache-and-network'
    },
    user: {
      query: gql`
        query {
          user: getViewer {
            id
            paypalAddress
          }
        }
      `
    }
  },
  data() {
    return {
      payoutStats: {}
      // recentPayouts: [
      //   {
      //     id: 1,
      //     date: 'Dec 31',
      //     amount: '0'
      //   },
      //   {
      //     id: 2,
      //     date: 'Nov 30',
      //     amount: '0'
      //   },
      //   {
      //     id: 3,
      //     date: 'Oct 31',
      //     amount: '0'
      //   }
      // ]
    }
  },
  computed: {}
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Payouts view page -->
    <div class="view-grid">
      <div>
        <!-- Payouts View Title -->
        <div class="display-1 font-weight-bold mb-3">
          Payouts
        </div>

        <div>
          <v-skeleton-loader
            :loading="$apollo.loading"
            transition="fade-transition"
            height="94"
            type="list-item-avatar-two-line"
          >
            <div>
              <!-- Next Payout -->
              <div class="payouts-view--item">
                <div class="subtitle-1 font-weight-bold">
                  Next payout
                </div>

                <v-layout align-center>
                  <div
                    class="flex s6 font-weight-bold primary--text headline mt-1"
                  >
                    RM {{ payoutStats.nextPayout || 0 | round(2) }}
                  </div>
                  <v-flex xs6 class="caption text-left">
                    <div>
                      Sent to your PayPal at the end of the month.
                    </div>
                  </v-flex>
                </v-layout>
              </div>

              <!-- Sales -->
              <div class="payouts-view--item mt-6">
                <div class="subtitle-1 font-weight-bold">
                  Sales
                  <span class="secondary--text font-weight-medium"
                    >(total)</span
                  >
                </div>

                <v-layout align-center>
                  <div class="flex xs6 font-weight-bold primary--text headline">
                    {{ payoutStats.salesCount }}
                  </div>
                  <v-flex xs6 class="caption text-left">
                    <ActiveDealsWrapper />
                  </v-flex>
                </v-layout>
              </div>

              <!-- Revenue -->
              <div class="payouts-view--item mt-6">
                <div class="subtitle-1 font-weight-bold">
                  Revenue
                  <span class="secondary--text font-weight-medium"
                    >(total)</span
                  >
                </div>

                <v-layout align-center>
                  <div class="flex xs6 font-weight-bold primary--text headline">
                    RM {{ payoutStats.revenue | round(2) }}
                  </div>
                  <v-flex xs6 class="caption text-left">
                    <ActiveDealsWrapper />
                  </v-flex>
                </v-layout>
              </div>

              <!-- Recent Payouts -->
              <div
                v-if="payoutStats.payouts && payoutStats.payouts.length > 0"
                class="payouts-view--item mt-6"
              >
                <div class="subtitle-1 font-weight-bold">
                  Recent payouts
                </div>
                <v-layout
                  v-for="payout in recentPayouts"
                  :key="payout.id"
                  class="my-3"
                >
                  <v-flex xs6>
                    {{ payout.date }}
                  </v-flex>
                  <v-flex xs6 class="secondary--text text-right">
                    RM {{ payout.amount | round(2) }}
                  </v-flex>
                </v-layout>
              </div>

              <!-- Paypal Address -->
              <v-layout class="payouts-view--item mt-6 mb-4">
                <v-flex>
                  <div class="subtitle-1 font-weight-bold">
                    PayPal address
                  </div>

                  <v-layout v-if="user" align-center>
                    <v-flex xs6>
                      {{ user.paypalAddress || 'Add PayPal address' }}
                    </v-flex>
                    <v-flex xs6 class="text-right">
                      <v-btn
                        outlined
                        icon
                        :to="{ name: 'PayoutsAddDetailsView' }"
                      >
                        <v-icon size="16" color="secondary"
                          >$vuetify.icons.pen</v-icon
                        >
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </v-skeleton-loader>
        </div>
      </div>
    </div>
  </transition>
</template>
